import _ from 'lodash';
import AppConstant from '../../../../config/app.constants';

class LocationsController {
  /*@ngInject*/
  constructor(Auth, $state, User, $translate, LocationService, $location, $q, Modal, ShipmentService, BranchService, 
              $scope, SetupService, Branch, DateUtil, BagoutService, DataCounter, ServiceOrderService, UsersService, $window,
              Navigation, TimezoneList, TransactionService, $rootScope, HoldService, FetchReactData) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.FetchReactData = FetchReactData;
    this.$state = $state;
    this.User = User;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.$q = $q;
    this.$scope = $scope;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.SetupService = SetupService;
    this.Branch = Branch;
    this.DateUtil = DateUtil;
    this.BagoutService = BagoutService;
    this.DataCounter = DataCounter;
    this.$location = $location;
    this.ServiceOrderService = ServiceOrderService;
    this.UsersService = UsersService;
    this.$window = $window;
    this.Navigation = Navigation;
    this.TimezoneList = TimezoneList;
    this.TransactionService = TransactionService;
    this.$rootScope = $rootScope;
    this.HoldService = HoldService;

    this.model = {
      branchId: this.User.getUser().branchId,
      search: null,
      dateRangeOptions: {
        startDate: null,
        endDate: null,
      },
      locationId: '',
      type: '',

      // date range picker for bagout tab
      dateRanges: {
        startDate: null,
        endDate: null,
      },
      dateRangPickerOptions: {},

      billingRulesDateRanges: {
        startDate: null,
        endDate: null
      },
      billingHistoryDateRanges: {
        startDate: null,
        endDate: null
      },
      // date range picker for service tab
      dateRangPickerOptionsfor: {},
      serviceHistoryData: {},
      loggedInUser: User.getUser().id,
      deliveryServiceHistory: [],
      pickupServiceHistory: [],
      timezone: null,
      timezoneList: this.TimezoneList.getTimezoneList(),
      currentStatsOfServiceHistory: 'single',
      fromLocationSearchText: null,
      toLocationSearchText: null,
      sortColumn: "completedAt",
			reverseSort: true,
      completedServiceTickets: [],
      isLoadingCompletedServiceOrder: false,
      deliveryServiceHistoryObj: {
        sortColumn: "serviceDate",
        reverseSort: false
      },
      atmServiceHistoryObj: {
        sortColumn: "serviceDate",
        reverseSort: false
      },
      pickupServiceHistoryObj: {
        sortColumn: "serviceDate",
        reverseSort: false
      },
      noPickupServiceHistoryObj: {
        sortColumn: "routeId",
        reverseSort: true
      }
    }
    this.sortOrderData = {};
    this.bucketsExpand = {};

    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: AppConstant.defaultPageLimit,
      maxPages: 10
    };

    this.pickupHistoryObj = {
      pagination: {
        page: 1,
        total: 0,
        pageLimit: AppConstant.defaultPageLimit,
        maxPages: 10
      }
    }

    this.deliveryHistoryObj = {
      pagination: {
        page: 1,
        total: 0,
        pageLimit: AppConstant.defaultPageLimit,
        maxPages: 10
      }
    };

    this.transactionHistoryObj = {
      results: [],
      totalRecords: 0,
      pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
      },
      loading: false
    };

    this.billingRulesObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page:1,
        total:0,
        pageLimit: 10,
        maxPages: 10
      },
      loading: false
    }

    this.billingHistoryObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page:1,
        total:0,
        pageLimit: 10,
        maxPages: 10
      },
      loading: false
    }

    this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.currentVaultDate = "";
    this.itemHistory = [];
    this.currentStats = "";
    this.locationData = "";
    this.isAllow = true;
    this.serviceTickets = false;
    this.serviceHistory = {};
    this.bucketExpanded = false;
    this.locationDetails = {};
    this.serviceHistoryStats = {
      single: 'single',
      all: 'all'
    }
    this.selectedDepositAmountValue = null;
    this.isLoading = false;
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach((permission) => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
  }

  print(stats = undefined) {
    let obj = {
      branchId: this.model.branchId,
      searchText: this.getLocationId(),
      startDate: moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59'),
      vaultDate: moment(this.currentVaultDate).format('MM-DD-YYYY'),
      currentStats: stats ? stats : this.currentStats,
      timezone: this.model.timezone,
      locationType: this.locationDetails.locationType,
      customerId: this.customerId || null,
      toLocationSearchText: this.model.toLocationSearchText,
      fromLocationSearchText: this.model.fromLocationSearchText,
      selectedDepositAmountValue: this.selectedDepositAmountValue,
      deliveryServiceHistoryObj: this.model.deliveryServiceHistoryObj,
      atmServiceHistoryObj : this.model.atmServiceHistoryObj,
      pickupServiceHistoryObj : this.model.pickupServiceHistoryObj,
      noPickupServiceHistoryObj : this.model.noPickupServiceHistoryObj
    }

    let url = this.$state.href('printLocation');
    window.w = window.open(url, '_blank');
    window.w.printData = obj;
  }

  // do not allow to paste string into datepicker
  dontAllow(element) {
    element.on('cut copy paste', function (event) {
      event.preventDefault();
    });
  }

  setDateRangeOptions(date, dateRangeOption, modelVal) {
    let currentVaultDate = moment(date).format() || moment();
    this.model[modelVal] = {
      autoApply: true,
      // maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
      eventHandlers: {
        'apply.daterangepicker': () => {
          this.pagination.page = 1;
          if (this.currentStats === "ServiceHistory") {
            // this.loadDataOfServiceHistory(dateRangeOption)
            // this.getPickupServiceHistory();
            // this.getDeliveryServiceHistory();
            this.getLocationDetail()
          }
          // if (this.currentStats === "ItemHistory") return this.loadDataOfItemHistory(dateRangeOption)
          if (this.currentStats === "BagoutHistory") return this.bagoutScanned(dateRangeOption)
          if (this.currentStats === "RepairHistory") return this.getCompletedServiceTickets(dateRangeOption)
          if(this.currentStats === "BillingRule") return this.getBillingRules(dateRangeOption)
          if(this.currentStats === "BillingHistory") return this.getBillingHistory(dateRangeOption)
        }
      },
      ranges: {
        'Running 67 Days': [
          moment(currentVaultDate).subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).add(7, 'days').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Today': [
          moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Week': [
          moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Month': [
          moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Year': [
          moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
        ]
      }
    }
  }

  $onInit() {
    this.loadPermission();
    this.locationData = this.DataCounter.getData();
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/locations');
    const transitionData = this.FetchReactData.getTransitionData();
    const queryLocationId = transitionData ? transitionData.locationId : this.$location.search().locationId;

    this.$q.all([
      this.SetupService.get(this.model.branchId),
      this.UsersService.getUserFieldData(this.model.loggedInUser)
    ])
      .then((data) => {
        this.currentVaultDate = this.DateUtil.getUTCDate(data[0].currentVaultDate);
        this.serviceTickets = data[0].serviceTickets;
        this.model.userdetails = data[1];
        this.model.timezone = this.model.userdetails.timezone ? this.model.userdetails.timezone : moment.tz.guess();
        // this.setDateRangeOptions(this.currentVaultDate, this.model.dateRanges, 'dateRangPickerOptions')
        // this.model.dateRanges.startDate = moment(this.currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss');
        // this.model.dateRanges.endDate = moment(this.currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');

        this.setDateRangeOptions(moment(), this.model.dateRangeOptions, 'dateRangPickerOptionsfor');
        this.model.dateRangeOptions.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
        this.model.dateRangeOptions.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
        this.model.billingRulesDateRanges.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
        this.model.billingRulesDateRanges.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
        this.model.billingHistoryDateRanges.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
        this.model.billingHistoryDateRanges.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
      })
      .then(() => {
        this.loadLocations('', 0);
        this.loadData();
        // After locations are loaded, set fromLocationId from query param if present
        if (queryLocationId) {
          this.model.fromLocationId = queryLocationId;
          this.FetchReactData.clearTransitionData();
          localStorage.setItem('locationData', JSON.stringify({
            locationId: queryLocationId,
            isRedirected: true
          }));
          this.getLocationDetail();
        }
        this.replaceURL();
      })
      .catch((err) => {
        console.log(err);
      });

    this.currentStats = "ServiceHistory";
    this.model.fromLocationId = "";
    this.model.tolocationId = "";
    this.model.isData = false;
    this.model.bagOutDetails = true;
    this.model.noDataDisplayed = true;
    this.model.records = this.$translate.instant('error.branch_mgmt.location');
    this.model.noDetailFound = this.$translate.instant('error.branch_mgmt.location');

    // Set up browser back button listener
    this.$window.onpopstate = (event) => {
      if (this.$state.current.name !== 'branchManagement.locations') {
        localStorage.removeItem('locationData');  // Clear data
      } else {
        const storedData = localStorage.getItem('locationData');
        if (storedData) {
          const data = JSON.parse(storedData);
          this.DataCounter.setData(data);
          localStorage.removeItem('locationData');
        }
      }
    };

    // Listen for state changes to clear data when not using back button
    this.$scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
      if (fromState.name !== 'branchManagement.locations') {
        // Clear data if navigating away from 'branchManagement.locations' state
        localStorage.removeItem('locationData');
      }
    });
  }

  loadData() {
    this.locationData = this.DataCounter.getData();
    if (this.locationData && this.locationData.isRedirected) {
      // this.model.fromLocationId = {
      //   Key: this.locationData.locationId,
      //   Value: this.locationData.locationId
      // };
      this.model.fromLocationId = this.locationData.locationId;
      if (this.locationData.vaultDate) {
        let date = this.DateUtil.getUTCDate(new Date());
        // let date = this.DateUtil.getUTCDate(this.locationData.vaultDate);
        let startDate = new Date(date).valueOf();
        let endDate = new Date(this.currentVaultDate).valueOf();
        this.model.dateRangeOptions.startDate = moment(date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        if (startDate > endDate) this.model.dateRangeOptions.endDate = moment(date).add(14, 'days').format('YYYY-MM-DD HH:mm:ss');
        else this.model.dateRangeOptions.endDate = moment(this.currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss');
      }
      // this.loadDataOfServiceHistory(this.model.dateRangeOptions);
      // this.getPickupServiceHistory();
      // this.getDeliveryServiceHistory();
      this.getLocationDetail()
    }
  }

  replaceURL() {
    let locationId;
    if (this.model.currentStatsOfServiceHistory === this.serviceHistoryStats.all && this.model.fromLocationId) locationId = this.model.fromLocationId.Value;
    else locationId = this.model.fromLocationId;

    const obj = { locationId, isRedirected: true };
    localStorage.setItem('locationData', JSON.stringify(obj))
    this.$state.transitionTo('branchManagement.locations', { id: locationId})
  }

  serviceHistoryTabSelection(selectedValue) {
    if (selectedValue === this.serviceHistoryStats.single) {
      setTimeout(() => {
        const el = document.getElementById('serviceHistorySingleSearch');
        if (el) el.focus();
      }, 100);
    }
    if (!this.model.fromLocationId) return;
    this.model.fromLocationId = null;
    this.reset();
  }

  tabSelection(selectedValue, date) {
    this.model.fromLocationId = this.getLocationId();
    let locationId = _.find(this.locationList, { Value: this.model.fromLocationId });
    if (this.model.fromLocationId && !locationId && !_.isEmpty(this.locationDetails)) {
      // locationId = {
      //   Key: this.locationDetails.locationId + ' | ' + this.locationDetails.locationName + ' | ',
      //   Value: this.locationDetails.locationId
      // }
      locationId = this.mappingLocationData([this.locationDetails], { id: 'locationId', name: 'locationName', address: 'locationAddress', city: 'locationCity', state: 'locationState', zip: 'locationZip', country: 'locationCountry'  })[0];
    }
    if (selectedValue == 'ServiceHistory') {
      this.model.currentStatsOfServiceHistory = this.serviceHistoryStats.single;
      this.pagination.page = 1;
      this.pickupHistoryObj.pagination.page = 1;
      this.deliveryHistoryObj.pagination.page = 1;
      this.setDateRange();
      this.getLocationDetail()
      // this.loadDataOfServiceHistory(date);
      // this.getDeliveryServiceHistory();
      // this.getPickupServiceHistory();
    }
    // else if (selectedValue == 'ItemHistory') {
    //   this.pagination.page = 1;
    //   this.loadDataOfItemHistory(date)
    // }
    else if (selectedValue == 'BagoutHistory') {
      this.model.fromLocationId = locationId;
      this.pagination.page = 1;
      this.setDateRange();
      this.bagoutScanned(date)
    }
    else if (selectedValue == 'RepairHistory') {
      this.model.fromLocationId = locationId;
      this.pagination.page = 1;
      this.setDateRange();
      this.getCompletedServiceTickets(date);
    }
    else if (selectedValue == 'BillingRule') {
      this.model.fromLocationId = locationId;
      this.billingRulesObj.pagination.page=1;
      this.setDateRange();
      this.getBillingRules(date)
    }
    else if (selectedValue == 'BillingHistory') {
      this.model.fromLocationId = locationId;
      this.billingHistoryObj.pagination.page=1;
      this.setDateRange();
      this.getBillingHistory(date)
    }
    this.currentStats = selectedValue;
  }

  isCustomerLocation(locationId) {
    if (!this.customerId) {
      return Promise.resolve(true);
    }
    return this.LocationService.hasCustomerLocation(locationId, this.customerId, this.model.branchId)
      .then(() => Promise.resolve(true))
      .catch((err) => {
        this.serviceHistory = { results: [] };
        this.locationDetails = {};
        this.model.isData = true;
        this.model.unableToFind = this.$translate.instant('error.branch_mgmt.location_not_found');
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
        return Promise.resolve(false);
      })
  }

  onLocationSelected() {
    this.$scope.$evalAsync(() => {
      this.getLocationDetail();
      this.replaceURL();
    });
  }

  getLocationDetail() {
    if (!this.model.fromLocationId) return;
    this.model.fromLocationSearchText = null;
    this.model.toLocationSearchText = null;
    this.model.pickupServiceHistoryObj.reverseSort = false;
    this.model.pickupServiceHistoryObj.sortColumn = "serviceDate";
    this.model.deliveryServiceHistoryObj.reverseSort = false;
    this.model.deliveryServiceHistoryObj.sortColumn = "serviceDate";
    this.isCustomerLocation(this.getLocationId())
      .then((allow) => {
        if (allow) {
          this.loadDataOfServiceHistory(this.model.dateRangeOptions);
          this.getDeliveryServiceHistory();
          this.getPickupServiceHistory();
          this.getNoPickupHistory();
        }
      })
      .catch((err) => {
        // this.model.pickupServiceHistory = [];
        // this.pickupHistoryObj.pagination.total
        // this.deliveryHistoryObj.pagination.total = 0;
        // this.model.deliveryServiceHistory = [];
        // this.serviceHistory = [];
        // this.serviceHistoryTotal = 0;
        this.serviceHistory = { results: [] };
        this.locationDetails = {};
        this.model.isData = true;
        this.model.unableToFind = this.$translate.instant('error.branch_mgmt.location_not_found');
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal('error.' + err.data.message);
        }
      })
  }
  // load transaction data based on fromLocation and refNumber
  loadDataOfServiceHistory(date) {
    var self = this;
    var searchData = this.getLocationId();

    if (!searchData) {
      return;
    }

    if (searchData != self.lastScanned) {
      self.pagination.page = 1;
    }

    date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    self.loading = true;
    self.model.isData = false;
    self.ShipmentService.ServiceItemHistory(searchData, date.startDate, date.endDate, (self.pagination.page - 1) * self.pagination.pageLimit, self.pagination.pageLimit, self.model.atmServiceHistoryObj.sortColumn, self.model.atmServiceHistoryObj.reverseSort)
    .then((data) => {
      if (data && data.results && data.results.length) {
        const orderNoGrp = new Map();
        data.results.forEach(cur => {
          const key = cur.parentLoadTrackingId;
          if (!orderNoGrp.has(key)) {
            orderNoGrp.set(key, {
              commonAttributes: {}, // to store shared attributes
              orders: [] // to store individual orders
            });
          }
          orderNoGrp.get(key).orders.push(cur);
        });
        // Extract common attributes and prepare final grouped data
      const groupedData = Array.from(orderNoGrp.entries()).map(([key, group]) => {
          const commonOrder = group.orders[0];

          return {
            orderNo: commonOrder.orderNo,
            deliveryAmount: group.orders.reduce((sum, order) => sum + order.deliveryAmount, 0),
            serviceDate: commonOrder.serviceDate,
            orderType: commonOrder.orderType,
            status: commonOrder.status,
            deletedReason: commonOrder.deletedReason,
            transType: commonOrder.transType || null,
            routeId: commonOrder.routeId,
            toLocationId: commonOrder.toLocationId,
            toLocationName: commonOrder.toLocationName, 
            loadTrackingId: commonOrder.parentLoadTrackingId ,
            residualTrackingId: commonOrder.parentResidualTrackingId ,
            isEC: commonOrder.isEC,
            deliveryDate: commonOrder.deliveryDate,
            deliveredFlag: commonOrder.deliveredFlag,
            fromLocationId: commonOrder.fromLocationId,
            fromLocationName: commonOrder.fromLocationName,
            residualAmount: group.orders.reduce((sum, order) => sum + order.residualAmount, 0),
            loadedAmount: group.orders.reduce((sum, order) => sum + order.loadedAmount, 0),
            amountCounted: group.orders.reduce((sum, order) => sum + order.amountCounted, 0),
            amountCRV: group.orders.reduce((sum, order) => sum + order.amountCRV, 0),
            packed: commonOrder.packed,
            fundingSourceId: commonOrder.fundingSourceId,
            denominations: _.uniqBy(group.orders.filter(order => order.denominationId), 'denominationId').map(order => ({
              denominationId: order.denominationId,
              deliveryAmount: order.deliveryAmount,
              amountCounted: order.amountCounted,
            })),
            parentLoadShipmentDetails: commonOrder.parentLoadShipmentDetails,
            parentResidualShipmentDetails: commonOrder.parentResidualShipmentDetails,
            finishedAt: commonOrder.finishedAt,
            amountVariance: commonOrder.amountVariance
          };
        });
        self.serviceHistory.results = groupedData;
        self.serviceHistoryTotal = data.total;
        // self.loading = false;
        // self.model.isData = false;
        self.lastScanned = searchData;
        self.vaultDate = moment(self.currentVaultDate).format('MM-DD-YYYY');
        self.calculateDays(date.startDate, date.endDate);
      }
        else {
        // self.loading = false;
        // self.model.isData = false;
        self.model.unableToFind = self.$translate.instant('error.branch_mgmt.location_not_found');
        self.serviceHistory = { results: [] };
        self.serviceHistoryTotal = 0;
        }
        self.locationDetails = {
          locationId: data.locationId,
          locationName: data.locationName,
          locationType: data.locationType,
          locationAddress: data.locationAddress,
          locationCity: data.locationCity,
          locationState: data.locationState,
          locationZip: data.locationZip,
          locationCountry: data.locationCountry
      }
      return data;
    })
      .then((data) => {
        if (this.locationData) {
          // this.model.fromLocationId = {
          //   Key: this.locationData.locationId + ' | ' + data.locationName,
          //   Value: this.locationData.locationId
          // };
          this.model.fromLocationId = this.locationData.locationId;
          this.locationData.isRedirected = false;
          this.locationData = this.DataCounter.setData();
        }
      })
      .catch((err) => {
        self.serviceHistory = { results: [] };
        self.locationDetails = {};
        self.serviceHistoryTotal = 0;
        self.model.isData = true;
        self.model.unableToFind = self.$translate.instant('error.branch_mgmt.location_not_found');

        if (err && err.data && err.data.message) {
          return this.Modal.errorModal('error.' + err.data.message);
        }
      })
      .finally(() => {
        self.model.isData = true;
        self.loading = false;
      });
  }

  pageChangeServiceHistory(date) {
    this.loadDataOfServiceHistory(date)
  }

  getOrderType(type) {
    return this.ShipmentService.getOrderType(type);
  }

  redirectToOrderPage(data) {
    const obj = {
      orderNo: data.orderNo,
      vaultDate: data.serviceDate,
      isRedirected: true,
      isCounted: (data.residualTrackingId && data.finishedAt) ? true : false,
      isInProcess: (data.residualTrackingId && !data.finishedAt) ? true : false,
      fundingSourceId: data.fundingSourceId
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.orders');
  }

  redirectToAtmCount(data) {
    const obj = {
      trackingId: data.residualTrackingId,
      isRedirected: true,
      fundingSourceId: data.fundingSourceId
    }
    this.DataCounter.setData(obj);
    this.$state.go('atmCount');
  }

  convertTime(microSeconds) {
    return this.ShipmentService.convertTime(microSeconds);
  }

  // load transaction data based on toLocation
  // loadDataOfItemHistory(date) {

  //   date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
  //   date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
  //   var searchData = this.model.fromLocationId;
  //   var self = this;

  //   if (searchData === '') {
  //     return;
  //   }

  //   if (searchData != self.lastScanned) {
  //     self.pagination.page = 1;
  //   }

  //   self.model.loading = true;
  //   return self.ShipmentService.LocationsItemHistory(searchData, date.startDate, date.endDate, (self.pagination.page - 1) * self.pagination.pageLimit, self.pagination.pageLimit)
  //     .then((data) => {
  //       if (data.results.length) {
  //         self.itemHistory = data;
  //         self.itemHistoryTotal = data.total;
  //         self.model.loading = false;
  //         self.model.noDataDisplayed = false;
  //         self.lastScanned = searchData;
  //         self.vaultDate = moment(self.currentVaultDate).format('MM-DD-YYYY');
  //       }
  //       else {
  //         self.model.loading = false;
  //         self.model.noDataDisplayed = false;
  //         self.model.noDataFound = self.$translate.instant('error.branch_mgmt.location_not_found');
  //         self.itemHistory = [];
  //         self.itemHistoryTotal = 0;
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       self.model.loading = false;
  //     });
  // }

  // pageChangeItemHistory(date) {
  //   this.loadDataOfItemHistory(date)
  // }

  // redirect user to specific location 
  editLocation(fromLocationId) {
    if (fromLocationId != null) {
      setTimeout(() => {
        this.Navigation.goToLocationTab(this.getLocationId());
      }, 200);
    } else {
      this.error = this.$translate.instant('error.branch_mgmt.locations_not_found');
    }
  }

  bagoutScanned(date) {
    if (this.model.loading || !this.model.fromLocationId) return;
    // this.model.loading = true;
    this.isCustomerLocation(this.model.fromLocationId.Value)
      .then((allow) => {
        if (allow) {
          this.loadBagoutScanned(date)
        }
      })
      .catch((err) => {
        this.model.unableToFind = this.$translate.instant('error.branch_mgmt.location_not_found');
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal(err.data.message);
        }
        this.model.loading = false;
        delete this.model.noDetailFound;
        this.model.bagOutDetails = false;
        this.bagOutData = null;
        this.bagOutTotal = 0;
        this.noDataFound = this.$translate.instant('common.no_data_found');
      })
  }

  // Load bagout history based on location
  loadBagoutScanned(date) {
    var searchText = this.model.fromLocationId ? this.model.fromLocationId.Value : null;

    var self = this;

    if (!searchText) {
      return;
    }

    if (searchText != self.lastScanned) {
      self.pagination.page = 1;
    }

    this.model.loading = true;
    date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');

    this.BagoutService.getBagoutData(searchText, date.startDate, date.endDate, this.customerId, (self.pagination.page - 1) * 
                                     self.pagination.pageLimit, self.pagination.pageLimit)
      .then((data) => {
        if (data.results.length) {
          this.model.loading = false;
          this.bagOutTotal = data.total;
          delete this.model.noDetailFound;
          this.localDateTime = moment(this.currentVaultDate).format('MM-DD-YYYY');
          this.bagOutData = data.results;
          self.lastScanned = searchText;
          self.calculateDays(date.startDate, date.endDate);
        }
        else {
          this.model.loading = false;
          delete this.model.noDetailFound;
          this.model.bagOutDetails = false;
          this.bagOutData = null;
          this.bagOutTotal = 0;
          this.noDataFound = this.$translate.instant('common.no_data_found');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.model.loading = false;
      })
  }

  pageChangeBagoutHistory(date) {
    this.bagoutScanned(date)
  }

  goToItemHistory(trackingId) {
    this.$state.go('branchManagement.items', {
      id: trackingId,
    });
  }

  showResidualReceipt(shipments) {
    shipments.trackingId = shipments.residualTrackingId;
    this.Modal.atmResidualReceipt(shipments, ({ modal }) => {
    }, ({ modal }) => {
      modal.close();
    });
  }

  goToContract(contractId){
    this.$state.go('contract.edit', {
      id:contractId
    })
  }

  exportServiceHistory() {
    var self = this;
    var searchData = this.getLocationId();
    var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    var reportPrefix = 'Service_History';

    self.isExporting = true;
    this.ShipmentService.exportServiceHistoryData(searchData, startDate, endDate, 0, 10000)
      .then((data) => {
        this.fileName = reportPrefix.concat('_', searchData, '.csv');
        let a = document.createElement("a");
        document.body.appendChild(a);
        let file = new Blob([data.reportData], { type: 'application/csv' });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = this.fileName;
        a.click();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        self.isExporting = false;
      })
  }

  exportBagoutHistory() {
    var self = this;
    var searchData = this.model.fromLocationId ? this.model.fromLocationId.Value : null;
    var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    var reportPrefix = 'Bagout_History';

    self.isExporting = true;
    this.BagoutService.exportBagoutHistory(searchData, startDate, endDate, 0, 100000)
      .then((data) => {
        this.fileName = reportPrefix.concat('_', searchData, '.csv');
        let a = document.createElement("a");
        document.body.appendChild(a);
        let file = new Blob([data.csvString], { type: 'application/csv' });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = this.fileName;
        a.click();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        self.isExporting = false;
      })
  }

  calculateDays(startDate, endDate) {
    let start = moment(startDate, 'YYYY-MM-DD');
    let end = moment(endDate, 'YYYY-MM-DD');
    let days = moment.duration(end.diff(start)).asDays();

    if ((days + 1) > 31) this.isAllow = false;
    else this.isAllow = true;

    return this.isAllow;
  }

  redirectToOrderPack(data) {
    const info = {
      routeId: data.routeId,
      vaultDate: data.serviceDate,
      locationId: data.fromLocationId,
      isRedirected: true,
      orderNo: data.orderNo,
      isEC: data.isEC,
      status: data.status,
      fundingSourceId: data.fundingSourceId
    }
    this.DataCounter.setPendingPackData(info);
    this.$state.go('orderPacking');
  }

  goToSoftDeleteShpTab(shipment) {
    const obj = {
      trackingId: shipment.loadTrackingId,
      isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('soft-deleted-shipments.all', {
      page: 1
    });
  }

  goToItemHold(shipment) {
    const obj = {
      trackingId: shipment.loadTrackingId,
      isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.itemHolds');
  }

  redirectTo(data) {
    if ((data.residualTrackingId) || (!data.residualTrackingId && data.status === 'shipment.deleted')) return this.goToItemHistory(data.loadTrackingId);
    else if (!data.residualTrackingId && data.loadTrackingId) return this.goToItemHistory(data.loadTrackingId);
    else return this.redirectToOrderPack(data);
  }

  // Load repair history
  getCompletedServiceTickets(date) {
    var searchText = this.model.fromLocationId ? this.model.fromLocationId.Value : null;
    var self = this;
    this.buckets = [];
    let bucketName = "";

    if (searchText != self.lastScanned) {
      self.pagination.page = 1;
    }

    this.model.isLoadingCompletedServiceOrder = true
    date.startDate = moment(self.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    date.endDate = moment(self.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');

    self.ServiceOrderService.getCompletedServiceTickets(searchText, self.pagination.pageLimit, (self.pagination.page - 1) * self.pagination.pageLimit, date.startDate, date.endDate, moment.tz.guess(), this.customerId, bucketName, this.model.reverseSort, this.model.sortColumn)
      .then((data) => {
        self.model.completedServiceTickets = data.results;
        self.model.completedServiceTicketsCount = data.totalRecords;
        self.lastScanned = searchText;

        let res = Object.keys(self.model.completedServiceTickets)
        res.map((key) => {
          if ((self.model.completedServiceTickets[key] && self.model.completedServiceTickets[key].items.length) || (key == 'COMPLETE' || key == 'CANCELLED')) this.buckets.push({ bucket: key });
        });

        this.buckets.forEach((d, i) => {
          if (this.bucketsExpand) {
            this.bucketsExpand[d.bucket] = {
              isExpanded: (this.bucketsExpand[d.bucket] && this.bucketsExpand[d.bucket].isExpanded) ? this.bucketsExpand[d.bucket].isExpanded : false,
              bucketName: d.bucket,
              child: (this.bucketsExpand[d.bucket] && this.bucketsExpand[d.bucket].child) ? this.bucketsExpand[d.bucket].child : {},

            }
            d.bucketExpanded = this.bucketsExpand[d.bucket].isExpanded || false;
          }

          self.model.completedServiceTickets[d.bucket].page = self.model.completedServiceTickets[d.bucket].page || 1;
          self.model.completedServiceTickets[d.bucket].limit = self.model.completedServiceTickets[d.bucket].limit || AppConstant.defaultPageLimit;
          self.model.completedServiceTickets[d.bucket].offset = self.model.completedServiceTickets[d.bucket].offset || 0;
          // this.sortData(this.model.sortColumn, d.bucket);

          if (!this.sortOrderData[d.bucket]) this.sortOrderData[d.bucket] = {};
          this.sortOrderData[d.bucket][this.model.sortColumn] = this.model.sortColumn
          this.sortOrderData[d.bucket][this.model.reverseSort] = true;
        })
        this.model.isLoadingCompletedServiceOrder = false; 

      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          self.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.isLoadingCompletedServiceOrder = false;
      })
  }

  // Load repair history sorting
  sortData = (column, bucket) => {
    if (!this.sortOrderData[bucket]) this.sortOrderData[bucket] = {};

    if (this.sortOrderData[bucket] && this.sortOrderData[bucket][this.model.sortColumn]) {
      this.sortOrderData[bucket][this.model.reverseSort] = (this.sortOrderData[bucket][this.model.sortColumn] === column) ? !this.sortOrderData[bucket][this.model.reverseSort] : false;
    }
    else this.sortOrderData[bucket][this.model.reverseSort] = false;

    this.sortOrderData[bucket][this.model.sortColumn] = column;
  }

  bucketSort(column, bucket) {
    if (!this.sortOrderData[bucket]) this.sortOrderData[bucket] = {};

    if (this.sortOrderData[bucket] && this.sortOrderData[bucket][this.model.sortColumn]) {
      this.sortOrderData[bucket][this.model.reverseSort] = (this.sortOrderData[bucket][this.model.sortColumn] === column) ? !this.sortOrderData[bucket][this.model.reverseSort] : false;
    }
    else this.sortOrderData[bucket][this.model.reverseSort] = false;

    this.sortOrderData[bucket][this.model.sortColumn] = column;
    if (bucket === 'COMPLETE' || bucket === 'CANCELLED') {
      this.pageChange(this.model.dateRangeOptions, bucket)
    }
  }

  getBucketName(status) {
    switch (status) {
      case 'INCOMPLETED':
        return this.$translate.instant('serviceTickets.incomplete');
      case status:
        return this.$translate.instant('serviceTickets.status_' + status);
      default: return;
    }
  }

  setStatusExpanded(bucketName) {
    this.bucketsExpand[bucketName].isExpanded = !this.bucketsExpand[bucketName].isExpanded;
  }

  calculateAssignAndAcceptTime(assignTime, acceptTime) {
    return moment(assignTime).isSameOrAfter(acceptTime);
  }

  calculateDuration(startDate, endDate) {
    let start = moment(startDate).valueOf();
    let end = moment(endDate).valueOf();

    if (start && end && end < start) { // reverse the date order
      const t = startDate;
      startDate = endDate;
      endDate = t;
    }

    let ms = moment(endDate).diff(startDate);
    let duration = moment.duration(ms);
    return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
  }


  loadOrderHistoryData(data, event) {
    if (data.expanded) {
      this.getServiceOrderHistory(data, event)
    }
    else {
      delete this.model.serviceHistoryData[data.serviceOrderId];
    }
    document.getElementById(`expand-btn-${data.serviceOrderId}`).blur();
  }

  getServiceOrderHistory(data, event) {
    this.serviceHistory[data.serviceOrderId] = { process: true };
    this.ServiceOrderService.serviceOrderHistory(data.encounterId, data.serviceOrderId, data.externalProcessorId)
      .then((history) => {
        this.model.serviceHistoryData[data.serviceOrderId] = { details: history };
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.serviceHistory[data.serviceOrderId].process = false;
      })
    event.preventDefault();
  }

  formatJsonObj(obj) {
    delete obj.notes;
    let details = JSON.stringify(obj);
    let addPipe = details.replace(/,/g, ' | ');
    let removeCurlyBraces = addPipe.replace(/[{}]/g, "");
    let finalObj = removeCurlyBraces.replace(/:/g, ": ");
    return finalObj.replace(/\"/g, "");
  }

  redirectToServiceHistory(locationId, locationName) {
    this.model.fromLocationId = locationId;
    document.getElementById("repair-history").classList.remove('active');
    document.getElementById("bagout-history").classList.remove('active');
    document.getElementById("service-history").classList.add('active');
    return this.tabSelection('ServiceHistory', this.model.dateRangPickerOptions)
  }

  goToServiceHistory(serviceOrder) {
    this.setDateRange();
    this.redirectToServiceHistory(serviceOrder.locationId, serviceOrder.locationName);
  }

  goToRouteTab(serviceOrder) {
    if (this.model.branchId === serviceOrder.branchId) {
      this.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
    }
    else {
      this.shiftBranch(this.model.loggedInUser, serviceOrder.branchId)
        .then(() => {
          this.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
        })
    }
  }

  redirectToRouteTab(routeId, vaultDate) {
    return this.Navigation.goToRouteTab(routeId, vaultDate, true, null);
  }
  
  goToRouteStatus(obj) {
    const date =  obj.countCompletedAt ? this.DateUtil.getTZFormattedDate(obj.pickupDate, this.model.timezone) : obj.serviceDate;
    this.redirectToRouteTab(obj.routeId, date);
  }

  shiftBranch(userId, selectedBranch) {
    var obj = {
      id: userId,
      branchId: selectedBranch
    };
    const defer = this.$q.defer();
    this.UsersService.updateUserBranch(obj.id, obj)
      .then((data) => {
        this.User.setUser(data);
        defer.resolve();
      })
      .catch((err) => {
        err.data.errors.map((e) => {
          this.errorMessage += e.message + '<br/>'
        })
        this.Modal.errorModal(this.errorMessage);
      });
    return defer.promise;
  }

  pageChange(date, bucketName) {
    let searchText = this.model.fromLocationId ? this.model.fromLocationId.Value : null;

    this.model.completedServiceTickets[bucketName].process = true;
    date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    this.ServiceOrderService.getCompletedServiceTickets(searchText, this.model.completedServiceTickets[bucketName].limit, (this.model.completedServiceTickets[bucketName].page - 1) * this.model.completedServiceTickets[bucketName].limit, date.startDate, date.endDate, moment.tz.guess(), this.customerId, bucketName, this.sortOrderData[bucketName] && this.sortOrderData[bucketName][this.model.reverseSort], this.sortOrderData[bucketName]&& this.sortOrderData[bucketName][this.model.sortColumn])// this.model.reverseSort, this.model.sortColumn
      .then((data) => {

        this.model.completedServiceTickets[bucketName].items = data.results[bucketName].items || [];
        this.model.completedServiceTickets[bucketName].totalCount = data.results[bucketName].totalCount || 0;

        if (this.model.completedServiceTickets[bucketName] && this.model.completedServiceTickets[bucketName].items.length) {
          this.isValid = true;
          this.model.completedServiceTickets[bucketName].items.forEach((info, index) => {
            this.model.completedServiceTickets[bucketName].items[index].expanded = this.bucketsExpand[bucketName].child[info.encounterId] || false;
          })
        }
        if (this.buckets.length <= 0) this.isValid = false;
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.completedServiceTickets[bucketName].process = false;
      })
  }

  setDateRangeForRepairHistory() {
    this.setDateRangeOptions(moment(), this.model.dateRangeOptions, 'dateRangPickerOptionsfor');
    this.model.dateRangeOptions.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
    this.model.dateRangeOptions.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');
  }

  goToUserTab(userId) {
    if (!userId) return;
    this.Navigation.goToUserTab(userId, null);
  }

  setDateRange() {
    this.setDateRangeOptions(moment(), this.model.dateRangeOptions, 'dateRangPickerOptionsfor');
    this.model.dateRangeOptions.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
    this.model.dateRangeOptions.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
  }

  validateBucket(event) {
    this.bucketExpanded = !this.bucketExpanded;
    event.preventDefault();
  }

  translateItemStatus(status) {
    if (!status) return;

    if (!status.startsWith('shipment')) return status;
    else if (status.startsWith('shipment')) return this.$translate.instant(status);
    else if (status.startsWith('CANT')) return this.$translate.instant(`shipment.${status}`)
    else return;
  }

  getDeliveryServiceHistory() {
    var searchText = this.getLocationId();
    var self = this;
    let LocationSearchText = null;

    if (!searchText) {
      return;
    }

    if (searchText != this.lastScanned) {
      this.pagination.page = 1;
    }

    this.model.loadDeliveryServiceHistory = true;
    this.model.isDeliveryServiceHistory = true;
    let startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
    let endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
    LocationSearchText = this.model.fromLocationSearchText;

    this.ShipmentService.getDeliveryServiceHistory(searchText, this.model.branchId, startDate, endDate, (this.deliveryHistoryObj.pagination.page - 1) * this.deliveryHistoryObj.pagination.pageLimit, this.deliveryHistoryObj.pagination.pageLimit, LocationSearchText, this.model.deliveryServiceHistoryObj.sortColumn, this.model.deliveryServiceHistoryObj.reverseSort)
      .then((data) => {
        this.deliveryHistoryObj.pagination.total = data.totalRecords;
        this.model.deliveryServiceHistory = data.results;
        this.lastScanned = searchText;
        // this.model.isDeliveryServiceHistory = true;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.model.loadDeliveryServiceHistory = false;
      })
  }

  getPickupServiceHistory() {
    var searchText = this.getLocationId();
    var self = this;
    let LocationSearchText = null;

    if (!searchText) {
      return;
    }

    if (searchText != this.lastScanned) {
      this.pagination.page = 1;
    }

    this.model.loadPickupServiceHistory = true;
    this.model.isPickupServiceHistory = false;

    let startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
    let endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
    LocationSearchText = this.model.toLocationSearchText;
    this.ShipmentService.getPickupServiceHistory(searchText, this.model.branchId, startDate, endDate, (this.pickupHistoryObj.pagination.page - 1) * this.pickupHistoryObj.pagination.pageLimit, this.pickupHistoryObj.pagination.pageLimit, LocationSearchText, this.model.pickupServiceHistoryObj.sortColumn, this.model.pickupServiceHistoryObj.reverseSort, this.model.timezone)
      .then((data) => {
        this.pickupHistoryObj.pagination.total = data.totalRecords;
        this.model.pickupServiceHistory = data.results;

        this.hasMatchingDepositRecord = this.model.pickupServiceHistory.some(pickupServiceHistory =>
          ['DEPOSIT', 'BULKCASH'].includes(pickupServiceHistory.shiptypeId) && pickupServiceHistory && pickupServiceHistory.isVariance
        );

        if (this.hasMatchingDepositRecord) {
          this.selectedDepositAmountValue = 'totalAmount';
        }
        else {
          this.selectedDepositAmountValue = null;
        }
      
        this.lastScanned = searchText;
        this.model.isPickupServiceHistory = true;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.model.loadPickupServiceHistory = false;
      })
  }

  reset() {
    if (!this.model.fromLocationId) {
      this.model.isData = false;
      this.model.isPickupServiceHistory = false;
      this.model.isDeliveryServiceHistory = false;
      this.transactionHistoryObj.isNopuTransactionHistory = false;
      this.pagination.page = 1;
      this.pickupHistoryObj.pagination.page = 1;
      this.deliveryHistoryObj.pagination.page = 1;
      this.serviceHistory = { results: [] };
      this.transactionHistoryObj.results = [];
    }
  }

  downloadFile(locationId, reportPrefix, reportData) {
    const fileName = reportPrefix.concat('_', locationId, '.csv');
    const a = document.createElement("a");
    document.body.appendChild(a);
    const file = new Blob([reportData], { type: 'application/csv' });
    const fileURL = window.URL.createObjectURL(file);
    a.href = fileURL;
    a.download = fileName;
    a.click();
  }

  exportDeliveryServiceHistory() {
    const locationId = this.getLocationId();
    const startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    const endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    const reportPrefix = 'Load_Delivery_Service_History';
    let LocationSearchText = null;
    LocationSearchText = this.model.fromLocationSearchText;

    this.model.isExportingDeliveryServiceHistory = true;
    this.ShipmentService.exportDeliveryServiceHistory(locationId, startDate, endDate, this.model.timezone, LocationSearchText, this.model.deliveryServiceHistoryObj.sortColumn, this.model.deliveryServiceHistoryObj.reverseSort)
      .then((data) => {
        this.downloadFile(locationId, reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.isExportingDeliveryServiceHistory = false;
      })
  }

  exportPickupServiceHistory() {
    const locationId = this.getLocationId();
    const startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    const endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    const reportPrefix = 'Pickup_Service_History';
    let LocationSearchText = null;
    LocationSearchText = this.model.toLocationSearchText;

    this.model.isExportingPickupServiceHistory = true;
    this.ShipmentService.exportPickupServiceHistory(locationId, startDate, endDate, this.model.timezone, LocationSearchText, this.selectedDepositAmountValue, this.model.pickupServiceHistoryObj.sortColumn, this.model.pickupServiceHistoryObj.reverseSort)
      .then((data) => {
        this.downloadFile(locationId, reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.isExportingPickupServiceHistory = false;
      })
  }

  translateTransactionType(tranType) {
    if (!tranType) return;
    else return this.$translate.instant(`shipment.${tranType}`);
  }

  showReceipt(shipments, stats) {
    this.Modal.shipmentImageModal(shipments, shipments.trackingId, stats, ({ modal }) => {
    }, ({ modal }) => {
      modal.close();
    });
  }

  // load all location
  loadLocations(searchKey, offset) {
    searchKey = searchKey || '';

    const searchObj = {
      queryJSON: {
        rules: [
          // {
          //   field: 'branchId',
          //   condition: '=',
          //   data: this.model.branchId
          // },
          // {
          //   field: 'active',
          //   condition: '=',
          //   data: true
          // },
          {
            field: 'locationType',
            condition: 'IN',
            data: ['REGULAR', 'ATM', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO', 'ON_CALL']
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'address',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
            ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      },
    }

    if (this.customerId) {
      searchObj.queryJSON.rules.push({
        field: 'customerId',
        condition: '=',
        data: this.customerId
      })
    }

    this.LocationService.all(searchObj, offset, AppConstant.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.totalRecord = data.total;
          this.locationList = this.mappingLocationData(data.results);
        }
        else {
          const location = this.mappingLocationData(data.results);
          this.locationList = this.locationList.concat(location);
        }
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
  }

  // mappingLocationData(location) {
  //   return location.map((loc) => {
  //     return {
  //       Key: loc.id + " | " + loc.name + " | (" + (loc.address ? loc.address + ", " : '') + (loc.city ? loc.city + ", " : '') + (loc.zip ? loc.zip + ", " : '') + (loc.state ? loc.state +( loc.country ?  ", " : '') : '') + loc.country + ")",
  //       Value: loc.id
  //     }
  //   });
  // }

  mappingLocationData(location, objKeys = {id: 'id',name: 'name', address:'address', city:'city', zip:'zip', state: 'state',country: 'country'}) {
    return location.map((loc) => {
      const id = loc[objKeys.id] || loc.id;
      const name = loc[objKeys.name] || loc.name;
      const address = loc[objKeys.address] || loc.address;
      const city = loc[objKeys.city] || loc.city;
      const zip = loc[objKeys.zip] || loc.zip;
      const state = loc[objKeys.state] || loc.state;
      const country = loc[objKeys.country] || loc.country;
  
      const addressParts = [];
  
      if (address) addressParts.push(address);
      if (city) addressParts.push(city);
      if (zip) addressParts.push(zip);
      if (state) addressParts.push(state);
      if (country) addressParts.push(country);
  
      const formattedAddress = addressParts.length > 0 ? `(${addressParts.join(', ')})` : '';
  
      return {
        Key: `${id} | ${name} | ${formattedAddress}`,
        Value: id
      };
    });
  }

  getNoPickupHistory() {
    const startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00');
    const endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    const searchText = this.getLocationId();

    if (!searchText) {
      return;
    }

    if (searchText != this.lastScanned) {
      this.transactionHistoryObj.pagination.page = 1;
    }

    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'trackingId',
            condition: '=',
            data: 'NOPU'
          },
          {
            field: 'transactionDate',
            condition: 'BETWEEN',
            data: [startDate, endDate]
          },
          {
            group: {
              rules: [{
                field: 'fromLocationId',
                condition: '=',
                data: searchText
              },
              {
                field: 'toLocationId',
                condition: '=',
                data: searchText
              }],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      },
      order: {
        fieldName: this.model.noPickupServiceHistoryObj.sortColumn,
        keyword: this.model.noPickupServiceHistoryObj.reverseSort ? 'ASC' : 'DESC'
      }
    }

    this.transactionHistoryObj.loading = true;
    this.transactionHistoryObj.isNopuTransactionHistory = false;
    this.TransactionService.all(searchObj, (this.transactionHistoryObj.pagination.page - 1) * this.transactionHistoryObj.pagination.pageLimit, this.transactionHistoryObj.pagination.pageLimit)
      .then((data) => {
        this.transactionHistoryObj.pagination.total = data.total;
        this.transactionHistoryObj.results = data.results;
        this.transactionHistoryObj.totalRecords = data.total;
        this.transactionHistoryObj.isNopuTransactionHistory = true;
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.transactionHistoryObj.loading = false;
      })
  }

  exportNoPickupTransactionHistory() {
    const startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00');
    const endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    const reportPrefix = 'No_Pickup_History';

    this.transactionHistoryObj.isExporting = true;
    this.TransactionService.exportNoPickupTransactionHistory(this.getLocationId(), startDate, endDate, this.model.timezone, this.model.noPickupServiceHistoryObj.sortColumn, this.model.noPickupServiceHistoryObj.reverseSort)
      .then((data) => {
        this.downloadFile(this.getLocationId(), reportPrefix, data.reportData)
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.transactionHistoryObj.isExporting = false;
      })
  }

  getNextNopuRecords() {
    this.getNoPickupHistory();
  }

  sendDeliveryOrPickupReceipt(row, stat) {
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_title'),
      message: this.$translate.instant('location.confirm_re_send_receipt', { stat }),
      callback: (({
        modal
      }) => {
        const formattedDate = this.DateUtil.getUTCDate(row.serviceDate),
          trackingId = row.trackingId,
          locationId = stat === 'delivery' ? row.toLocationId : row.fromLocationId,
          branchId = row.branchId,
          routeId = row.routeId,
          providedEmails = null;

        this.isSending = true;
        this.LocationService.sendDeliveryOrPickupReceipt(trackingId, locationId, branchId, routeId, formattedDate, providedEmails, this.selectedDepositAmountValue, this.model.timezone, stat.toUpperCase())
          .then(() => { })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              this.Modal.errorModal(err.data.message)
            }
          })
          .finally(() => {
            modal.close();
            this.isSending = false;
          })
      }),
      type: 'success'
    })
  }

  sendOrderReceipt(row) {
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_title'),
      message: this.$translate.instant('location.confirm_re_send_order_receipt'),
      callback: (({
        modal
      }) => {
        const formattedDate = this.DateUtil.getUTCDate(row.serviceDate),
          orderNo = row.orderNo,
          locationId = row.toLocationId,
          branchId = row.branchId,
          routeId = row.routeId,
          providedEmails = null;

        this.isSending = true;
        this.LocationService.sendOrderReceipt(orderNo, locationId, branchId, routeId, formattedDate, providedEmails)
          .then(() => { })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              this.Modal.errorModal(err.data.message)
            }
          })
          .finally(() => {
            modal.close();
            this.isSending = false;
          })
      }),
      type: 'success'
    })
  }

  clearData() {
    if(!this.model.fromLocationId) {
      this.serviceHistory.results = [];
      this.serviceHistoryTotal = 0;
      this.model.deliveryServiceHistory = [];
      this.model.pickupServiceHistory = [];
      this.transactionHistoryObj.results = [];
      this.model.isData = false;
      this.model.toLocationSearchText = null
      this.model.fromLocationSearchText = null;
    }
  }

  getLocationId() {
    const transitionData = this.FetchReactData.getTransitionData();
    if (transitionData && transitionData.locationId) {
      return transitionData.locationId;
    }
    if (this.model.currentStatsOfServiceHistory === this.serviceHistoryStats.single && this.model.fromLocationId) {
      const locationId = typeof this.model.fromLocationId === 'object' ? this.model.fromLocationId.Value : this.model.fromLocationId;
      return locationId;
    }
    else if (this.model.currentStatsOfServiceHistory === this.serviceHistoryStats.all && this.model.fromLocationId) return this.model.fromLocationId.Value;
  }

  setAmount(obj) {
    if (!obj) return;
    return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount
    // const status = ['Hold'];

    // if (status.includes(this.translateItemStatus(obj.status))) {
    //   return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount;
    // }
    // else return obj.formattedLoadedAmount
  }

  getBillingRules(date){
    this.billingRulesObj.loading = true;
    const locationId = typeof this.model.fromLocationId === 'object' && this.model.fromLocationId ? this.model.fromLocationId.Value : this.model.fromLocationId;
    if(!locationId) return
    date.startDate = moment(this.model.billingRulesDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
    date.endDate = moment(this.model.billingRulesDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
    this.LocationService.getBillingRulesByLocationId(locationId,(this.billingRulesObj.pagination.page - 1) * this.billingRulesObj.pagination.pageLimit, this.billingRulesObj.pagination.pageLimit, date.startDate, date.endDate).then((res) => {
      this.billingRulesObj.results = res.result;
      this.billingRulesObj.totalRecords = res.totalRecords;
      this.billingRulesObj.pagination.total = res.totalRecords;
      this.billingRulesObj.loading = false;
    })
  }

  getBillingHistory(date){
    this.billingHistoryObj.loading = true;
    const locationId = typeof this.model.fromLocationId === 'object' && this.model.fromLocationId ? this.model.fromLocationId.Value : this.model.fromLocationId;
    if(!locationId) return
    date.startDate = moment(this.model.billingHistoryDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
    date.endDate = moment(this.model.billingHistoryDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
    this.LocationService.getBillingHistory(locationId,(this.billingHistoryObj.pagination.page - 1) * this.billingHistoryObj.pagination.pageLimit, this.billingHistoryObj.pagination.pageLimit, date.startDate, date.endDate).then((res) => {
      this.billingHistoryObj.results = res.results;
      this.billingHistoryObj.totalRecords = res.total;
      this.billingHistoryObj.pagination.total = res.total;
      if(this.billingHistoryObj.results){
        this.billingHistoryObj.results.forEach((log) => {
  
          log.readableEntryType = this.$translate.instant('entry_type.' + log.entryType)
          if (log.entryData) {
            log.extraDetails = Object.entries(log.entryData).map((entry) => {
              return {
                key: entry[0],
                value: typeof entry[1] === 'object' ? JSON.stringify(entry[1]) : entry[1]
              };
            });
          }
        });
      }
      this.billingHistoryObj.loading = false;
    })
  }

  exportBillingLocations(){
    const locationId = typeof this.model.fromLocationId === 'object' ? this.model.fromLocationId.Value : this.model.fromLocationId;
    if(!locationId) return
    var startDate = moment(this.model.billingRulesDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
    var endDate = moment(this.model.billingRulesDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
    var reportPrefix = 'Billing_Rules';
    this.LocationService.exportBillingRulesByLocationId(locationId, startDate, endDate).then((res) => {
      this.fileName = reportPrefix.concat('_', locationId, '.csv');
        let a = document.createElement("a");
        document.body.appendChild(a);
        let file = new Blob([res.csvString], { type: 'application/csv' });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = this.fileName;
        a.click();
    })
  }

  exportBillingHistory(){
    const locationId = typeof this.model.fromLocationId === 'object' ? this.model.fromLocationId.Value : this.model.fromLocationId;
    if(!locationId) return
    var startDate = moment(this.model.billingHistoryDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
    var endDate = moment(this.model.billingHistoryDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
    var reportPrefix = 'Billing_History';
    this.LocationService.exportBillingHistory(locationId, startDate, endDate).then((res) => {
      this.fileName = reportPrefix.concat('_', locationId, '.csv');
        let a = document.createElement("a");
        document.body.appendChild(a);
        let file = new Blob([res.csvString], { type: 'application/csv' });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = this.fileName;
        a.click();
    })
  }

  deliveryServiceTransactionModal(obj) {
    const formattedDate = moment(obj.serviceDate).format('YYYY-MM-DD');
    this.Modal.deliveryServiceTransaction(obj.toLocationId, this.model.branchId, formattedDate, obj.trackingId, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  depositPopover(pickupServiceHistory) {
    return `<div><b>Stated Value</b>: ${this.formatAmount(pickupServiceHistory.statedTotalAmount)}</div>
    <div><b>Declared Value</b>: ${this.formatAmount(pickupServiceHistory.declaredTotalAmount)}</div>
    <div><b>Counted Value</b>: ${this.formatAmount(pickupServiceHistory.totalAmount)}</div>
    <div><b>Counted Variance</b>: ${this.formatAmount(pickupServiceHistory.countedVariance)}</div>`
  }

  formatAmount(amount) {
    let formatted = amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return formatted;
  }
  
  sortDeliveryServiceHistoryData(column, event) {
    this.model.deliveryServiceHistoryObj.reverseSort = (this.model.deliveryServiceHistoryObj.sortColumn == column) ? !this.model.deliveryServiceHistoryObj.reverseSort : false;
    this.model.deliveryServiceHistoryObj.sortColumn = column;
    this.getDeliveryServiceHistory();
    event.preventDefault();
  }

  sortAtmServiceHistoryData(column, event, date) {
    this.model.atmServiceHistoryObj.reverseSort = (this.model.atmServiceHistoryObj.sortColumn == column) ? !this.model.atmServiceHistoryObj.reverseSort : false;
    this.model.atmServiceHistoryObj.sortColumn = column;
    this.loadDataOfServiceHistory(date)
    event.preventDefault();
  }

  sortPickupServiceHistoryData(column, event) {
    this.model.pickupServiceHistoryObj.reverseSort = (this.model.pickupServiceHistoryObj.sortColumn == column) ? !this.model.pickupServiceHistoryObj.reverseSort : false;
    this.model.pickupServiceHistoryObj.sortColumn = column;
    this.getPickupServiceHistory();
    event.preventDefault();
  }
  sortNoPickupServiceHistoryData(column, event) {
    this.model.noPickupServiceHistoryObj.reverseSort = (this.model.noPickupServiceHistoryObj.sortColumn == column) ? !this.model.noPickupServiceHistoryObj.reverseSort : false;
    this.model.noPickupServiceHistoryObj.sortColumn = column;
    this.getNoPickupHistory();
    event.preventDefault();
  }

  convertToCrv(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;

    this.UsersService.checkSupervisor(this.model.loggedInUser)
      .then((userInfo) => {
        this.Modal.convertToCrv(shipment, !userInfo.supervisor, true, ({ supervisor, trackingIdResidual, modal }) => {
          if (trackingIdResidual) {
            this.HoldService.convertToCRV(this.model.branchId, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor)
              .then((data) => {
                modal.close();
                this.isLoading = false;
                this.getDeliveryServiceHistory();
              })
              .catch((err) => {
                modal.close();
                if (err && err.data && err.data.message) {
                  this.isLoading = false;
                  this.Modal.errorModal('error.' + err.data.message)
                }
              })
          }
          else {
            if (modal) modal.close();
            this.isLoading = false;
          }
        }, ({ modal }) => {
          if (modal) modal.close();
          this.isLoading = false;
        })
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
        this.isLoading = false;
      })
  }

  convertToCrvPackableOrder(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.Modal.confirm({
      header: 'Confirm CRV Conversion', 
      message: 'Are you sure you want to convert this Shipment to CRV?', 
      callback: ({ modal, $scope }) => {
        modal.close();
        this.UsersService.checkSupervisor(this.model.loggedInUser)
          .then((userInfo) => {
            this.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, ({ modal: supModal, supId }) => {
              supModal.close();
              this.HoldService.convertToCrvPackableOrder(this.model.branchId, shipment.trackingId, shipment.packableOrderShipmentId, supId)
                .then((data) => {
                  this.isLoading = false;
                  this.getDeliveryServiceHistory();
                })
                .catch((err) => {
                  if (err && err.data && err.data.message) {
                    this.isLoading = false;
                    this.Modal.errorModal('error.' + err.data.message);
                  }
                });
            }, ({ modal: supModal }) => {
              supModal.close();
              this.isLoading = false;
            });
          })
          .catch((err) => {
            this.Modal.errorModal(err.data.message);
            this.isLoading = false;
          });
      },
      negative: ({ modal, $scope }) => {
        modal.close();
        this.isLoading = false;
      }
    });
  }

  convertShipmentToCrv(shipment) {
    if (shipment.packableOrderShipmentId) {
      this.convertToCrvPackableOrder(shipment);
    } else {
      this.convertToCrv(shipment);
    }
  }

  redirectToCashCount(item) {
    return this.Navigation.goToAtmCount(item.trackingId, true, null, item.fundingSourceId)
  }
}

export default LocationsController; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/locations/locations.controller.js